import { eventKeyConstants } from './eventKey';

export const tabListHelper = (refID : string, cb : any, event : any) => {
  const refElem = document.getElementById(refID);
  const childEl = refElem.children;

  switch (event.key) {
    case eventKeyConstants.ENTER:
    case eventKeyConstants.SPACE:
      event.preventDefault();
      cb();
      break;
    case eventKeyConstants.ARROWRIGHT:
      event.preventDefault();
      if (!event.target.nextSibling) {
        (childEl[0] as HTMLElement).focus();
      } else {
        (event.target.nextSibling).focus();
      }
      break;
    case eventKeyConstants.ARROWLEFT:
      event.preventDefault();
      if (!event.target.previousSibling) {
        (childEl[childEl.length - 1] as HTMLElement).focus();
      } else {
        (event.target.previousSibling).focus();
      }
      break;
    case eventKeyConstants.HOME:
      event.preventDefault();
      (childEl[0] as HTMLElement).focus();
      break;
    case eventKeyConstants.END:
      event.preventDefault();
      (childEl[childEl.length - 1] as HTMLElement).focus();
      break;
    default:
      // not to prevent synthetic events for other keys
      break;
  }
}
